import React, { useState, useEffect } from 'react';
import { Sparkles, Check } from 'lucide-react';
import { pricingData, addOns } from '../data/mock';

const Prices = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="py-20 px-4 pt-32">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div
          className={`text-center mb-12 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-cyan-300 via-teal-400 to-cyan-400 bg-clip-text text-transparent mb-4 flex items-center justify-center gap-3">
            <Sparkles className="w-10 h-10 text-cyan-400 animate-pulse" />
            Commission Prices
          </h1>
          <p className="text-xl text-gray-300">
            Professional avatar retexturing for VRChat and VTubing
          </p>
        </div>

        {/* Pricing cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {pricingData.map((plan, index) => (
            <div
              key={plan.id}
              className={`transition-all duration-700 ${
                visible
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div
                className={`rounded-xl border text-card-foreground relative h-full transition-all duration-300 hover:scale-105 backdrop-blur ${
                  plan.highlighted
                    ? 'bg-gradient-to-br from-cyan-500/20 to-teal-500/20 border-cyan-400 shadow-xl shadow-cyan-500/20'
                    : 'bg-slate-800/40 border-slate-700 hover:border-teal-500/50 shadow'
                }`}
              >
                {plan.badge && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                    <span className="inline-flex items-center rounded-md border-transparent shadow bg-cyan-500 text-white px-4 py-1 text-sm font-semibold">
                      {plan.badge}
                    </span>
                  </div>
                )}
                <div className="p-6 pb-4">
                  <h3 className="font-semibold tracking-tight text-2xl text-white mb-2">
                    {plan.title}
                  </h3>
                  <p className="text-gray-400 text-sm">{plan.description}</p>
                </div>
                <div className="p-6 pt-0">
                  <div className="mb-6">
                    <span className="text-5xl font-bold text-cyan-400">
                      ${plan.price}
                    </span>
                  </div>
                  <div className="space-y-3">
                    {plan.features.map((feature, i) => (
                      <div key={i} className="flex items-start gap-3">
                        <div className="mt-0.5 rounded-full bg-cyan-500/20 p-1">
                          <Check className="w-4 h-4 text-cyan-400" />
                        </div>
                        <span className="text-gray-300 text-sm">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Add-ons */}
        <div
          className={`text-center space-y-4 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
          style={{ transitionDelay: '600ms' }}
        >
          {addOns.map((addon, i) => (
            <div
              key={i}
              className={`rounded-xl border text-card-foreground backdrop-blur-xl shadow-xl ${
                addon.color === 'cyan'
                  ? 'bg-gradient-to-r from-cyan-500/20 to-teal-500/20 border-cyan-400/40 shadow-cyan-500/20'
                  : 'bg-gradient-to-r from-amber-600/20 to-yellow-600/20 border-amber-500/40 shadow-amber-600/20'
              }`}
            >
              <div className="p-6">
                <p
                  className={`text-lg font-semibold ${
                    addon.color === 'cyan' ? 'text-cyan-300' : 'text-amber-300'
                  }`}
                >
                  {addon.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Prices;
